import * as React from "react";
import { useWebPortalApiClient, useWebPortalLegacyClient } from "../../misc/api/WebPortalTokenClient";
import Alert, { AlertCategoryEnum } from "../../misc/components/Alert";
import Modal from "../../misc/components/modal";

export interface ImportPermissionsProps {
    roleId: string;
    onClose: () => void;
}

export const ImportPermissions = ({ roleId, onClose }: ImportPermissionsProps) => {
    const [selectedFile, setSelectedFile] = React.useState<File>();
    const legacyClient = useWebPortalLegacyClient();
    const client = useWebPortalApiClient();
    const [error, setError] = React.useState<string | undefined>();
    const [warning, setWarning] = React.useState<string | undefined>();

    const checkForOverwrittenRoles = async () => {
        let roles = [];
        try {
            roles = JSON.parse(await selectedFile.text());
        } catch {
            setError("The imported file must a valid JSON file.")
            return;
        }
        const roleNamesToCheck = [];
        if (!Array.isArray(roles)) {
            setError("Incorrect format. The imported file must be a collection of roles with permissions");
            return;
        }
        for (const role of roles) {
            if (role["RoleName"] === undefined)
                continue;

            roleNamesToCheck.push(`'${role["RoleName"]}'`);
        }
        const roleNamesString = roleNamesToCheck.join(",");

        const roleResult = client.client.getRoles(undefined, `name in (${roleNamesString})`);

        if ((await roleResult).value.length > 0) {
            setWarning(`Roles with the name(s) ${roleNamesString} already exist and will be overwritten?`);
            return;
        }
        await onImport(undefined, selectedFile);
        
    }

    const onSaveClick = async () => {
        setError(undefined);
        if (selectedFile?.type !== "application/json") {
            setError("The imported file must a valid JSON file.")
            return;
        }

        if (roleId === null || roleId === undefined) {
            checkForOverwrittenRoles();
            return;
        }

        await onImport(roleId, selectedFile);      
    }

    const onImport = async (roleToImportForId: string, file: File) => {
        try {
            await legacyClient.importPermissionsApi(roleToImportForId, file);
            onClose();
        } catch (ex) {
            setError(ex.Message);
        }
    }

    return (
        <Modal show={true} header="Import Permissions to Role">
            <div className="row">
                <div className="col-md-12">
                    <div className="panel-body">
                        {error ? <Alert show={true} category={AlertCategoryEnum.Danger}>{error}</Alert> : null}
                        {warning ? <Alert show={true} category={AlertCategoryEnum.Warning}>{warning}</Alert> : null}
                        <div className="form-group">
                            <input type="file" className="form-control" onChange={(e) => setSelectedFile(e.target.files[0])} />
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                {!warning ? <button id="importButton" className="btn btn-primary" type="submit" disabled={false} onClick={onSaveClick}>
                    Import
                </button> : null}&nbsp;
                {warning ? <button id="importButton" className="btn btn-warning" type="submit" disabled={false} onClick={() => onImport(roleId, selectedFile)}>
                    Import ignoring warnings
                </button> : null}&nbsp;
                <button id="returnToListButton" className="btn btn-primary btn-outline" onClick={onClose}>
                    Return to List
                </button>
            </div>
        </Modal>
    );
}
